import { NastavitevDto } from "../../types/Natavitev/NastavitevDtoType";
import Nullable from "../../types/Nullable";

class NastavitveProvider {
   readonly ExtCode: string = "default";

   constructor(_nastavitevList: Nullable<NastavitevDto[]>) {
      if (_nastavitevList == null)
         return;
      const nastavitveMap: Map<string, any> = new Map(_nastavitevList.map((obj) => [obj.ime, this.getNastavitevValue(obj)]));

      this.ExtCode = nastavitveMap.get("ExtCode") as string;
   }

   getNastavitevValue(nastavitev: NastavitevDto): any {
      if (nastavitev.tekst != null)
         return nastavitev.tekst;
      else if (nastavitev.celoStevilo != null)
         return nastavitev.celoStevilo;
      else if (nastavitev.datum != null)
         return nastavitev.datum;
      else if (nastavitev.decimalnoStevilo != null)
         return nastavitev.decimalnoStevilo;
      else if (nastavitev.logicnaVrednost != null)
         return nastavitev.logicnaVrednost;
      else
         throw new Error(`Nastavitev "${nastavitev.ime}" nima vrednosti`);
   }

   // genericTestFunction<T>(value: T) {
   //    // Try cast to string
   //    if (typeof value === "string") {
   //       console.log(value.length);
   //    }
   // }
}

export default NastavitveProvider